import ApplicationController from "./application_controller.js"

function show(el, showHide) {
  el.setAttribute("style", showHide ? "" : "display:none")
}

export default class extends ApplicationController {
  static targets = [ "resultsPanel", "documentList", "submitButton" ]

  connect() {
    if (this.questionsComplete) {
      this.showPreview()
    }
  }

  get questionsComplete() {
    return $(".package-question:visible").length > 0 &&
      $(".package-question:visible").length == $('.package-question:visible input:checked').length
  }

  question_answered(ev) {
    let name = ev.target.name.match(/\[.*?\]\[(.*?)\]/)[1]

    $('*[data-hide-when]').toArray().forEach((el) => {
      let [hideName, hideVal] = $(el).data("hide-when").split('=')
      if (hideName == name) {
        show(el, hideVal == ev.target.value)
      }
    })

    if (this.questionsComplete) {
      this.showPreview()
    } else {
      this.hide("resultsPanel")
    }
  }

  async showPreview() {
    this.disableButton("submitButton")
    const html = await $.ajax({url: this.data.get('refresh-url') + '.js', data: $(this.element).serialize(), dataType: 'html'})
    this.resultsPanelTarget.innerHTML = html
    this.show("resultsPanel")
    this.enableButton("submitButton")
  }
}
